// Place the URL here with the /api suffix.
// Ex.:`https://domain.com/api`;
const backendUrl = `https://g0ac2ands9.execute-api.eu-north-1.amazonaws.com/api`;

// SwaggerUI Documentation URL
// Leave black if documentation should be hidden
const apiDocumentationUrl = `/documentation`;

/**
 * Frontend URL.
 */
const frontendUrl = {
  host: 'app.eu-label.info',
  protocol: 'https',
};

const eLabelPublicUrl = {
  host: 'https://app.eu-label.info',
  hostNew: 'https://view.eu-label.info',
  path: '/view',
};

/**
 * Tenant Mode
 * multi: Allow new users to create new tenants.
 * multi-with-subdomain: Same as multi, but enable access to the tenant via subdomain.
 * single: One tenant, the first user to register will be the admin.
 */
const tenantMode = 'multi';

/**
 * Plan payments configuration.
 */
const isPlanEnabled = true;
const stripePublishableKey =
  'pk_live_51NnJ4wLZL0GvpUbMVNYPmQ183SV7hQxAZ3N0LvsQ2XNuHnnJ95KSBW4KVy0ChoJEJfbS7xbBYTwfwsb2j835P7Tw00YMv3B8QF';

/**
 * Symple Analytics Keys
 */

const simpleAnalytics = {
  apiKey: 'sa_api_key_D8rqFfj5pYVFnvddktr7f6ZCvYUjxS1C5Td6',
  userId: 'sa_user_id_47bdfc21-e5a0-4f33-a83a-5f0b06769633',
  apiUrl: 'https://simpleanalytics.com/app.eu-label.info.json?version=5',
};

export default {
  frontendUrl,
  backendUrl,
  apiDocumentationUrl,
  tenantMode,
  isPlanEnabled,
  stripePublishableKey,
  eLabelPublicUrl,
  simpleAnalytics,
};
